export const shellAuditArabicTranslations: Record<string, string> = {
  'Log contact': 'تسجيل التواصل',
  'Record the contact result using the options available on the page.': 'توثيق نتيجة التواصل مع العميل من الخيارات الموجودة قدامك.',
  'After contacting a customer, when you need to record the result.': 'بعد ما تتواصل مع العميل وتحتاج تسجّل اللي حصل.',
  'Choose the right customer and check their name and phone number.': 'اختار العميل الصح واتأكد من الاسم والرقم.',
  'Review the latest activity if history is available on the page.': 'راجع آخر نشاط لو السجل متاح في الصفحة.',
  'Write the contact result in the available note or comment.': 'اكتب نتيجة التواصل في الملاحظة أو التعليق الموجود.',
  'Review the result before saving or confirming the decision.': 'راجع النتيجة قبل الحفظ أو تأكيد القرار.',
  'The contact result stays clear for the team in the work history.': 'نتيجة التواصل تفضل واضحة للفريق في سجل الشغل.',
  'Record what actually happened and check the customer before confirming.': 'اكتب اللي حصل فعلًا وراجع العميل قبل التأكيد.',
  'Account settings': 'إعدادات الحساب',
  'Example: move a lead, follow-up or tasks': 'مثال: نقل عميل أو متابعة أو مهام',
  'Critical now': 'مهم دلوقتي', 'Daily actions': 'أكشنز يومية', 'Low priority': 'أولوية منخفضة',
  'Critical': 'حرج', 'High': 'عالي', 'Normal': 'عادي', 'Low': 'منخفض', 'System': 'النظام',
  'Acknowledge': 'اطلعت عليه',
  'No linked page for this notification.': 'مفيش صفحة مرتبطة بالإشعار ده.',
  'Critical notifications stay visible.': 'الإشعارات الحرجة بتفضل ظاهرة.',
  'Notifications, {0} unread': 'الإشعارات، {0} غير مقروء',
  'Browser notifications were not enabled. Check browser permissions.': 'إشعارات المتصفح متفعّلتش. راجع أذونات المتصفح.',
  'New sheet lead': 'عميل جديد من الشيت', 'Sheet lead updated': 'تم تحديث عميل من الشيت',
  'Transfer request rejected': 'طلب التحويل اترفض', 'Transfer request approved': 'طلب التحويل اتوافق عليه',
  'New Lead request': 'طلب إضافة عميل جديد', 'New Lead request approved': 'طلب إضافة العميل اتوافق عليه',
  'New Lead request rejected': 'طلب إضافة العميل اترفض', 'New Lead request returned for editing': 'طلب إضافة العميل رجع للتعديل',
  'A follow-up task is overdue and needs action now.': 'مهمة متابعة متأخرة ومحتاجة أكشن دلوقتي.',
  'A follow-up reminder is due soon.': 'تذكير المتابعة قرب ميعاده.',
  'A review request has a new response.': 'فيه رد جديد على طلب المراجعة.',
  'Transfer request was rejected. Review reason and next step.': 'طلب التحويل اترفض. راجع السبب والخطوة الجاية.',
  'Transfer request was approved.': 'طلب التحويل اتوافق عليه.',
  'A new lead was assigned to you (Lead #{0}).': 'اتعيّن لك عميل جديد (رقم {0}).',
  'A new lead was assigned to you.': 'اتعيّن لك عميل جديد.',
  '{0} submitted a sales inquiry for {1} from {2}.': '{0} بعت طلب للسيلز عن {1} من {2}.',
  '{0} submitted a sales inquiry for {1}.': '{0} بعت طلب للسيلز عن {1}.',
  '{0} submitted a sales inquiry from {1}.': '{0} بعت طلب للسيلز من {1}.',
  '{0} submitted a sales inquiry.': '{0} بعت طلب للسيلز.',
  '{0} registered from the sales link for {1}.': '{0} سجّل من رابط السيلز في {1}.',
  '{0} registered from the sales link.': '{0} سجّل من رابط السيلز.',
  '{0} requested adding {1} ({2}) for {3}.': '{0} طلب إضافة {1} ({2}) في {3}.',
  '{0} requested adding {1} ({2}).': '{0} طلب إضافة {1} ({2}).',
  '{0} requested adding {1} for {2}.': '{0} طلب إضافة {1} في {2}.',
  '{0} requested adding {1}.': '{0} طلب إضافة {1}.',
  '{0}: approved - {1}.': '{0}: اتوافق عليه - {1}.',
  '{0}: rejected - {1}.': '{0}: اترفض - {1}.',
  '{0}: returned for editing - {1}.': '{0}: رجع للتعديل - {1}.',
  '{0}: approved.': '{0}: اتوافق عليه.', '{0}: rejected.': '{0}: اترفض.',
  '{0}: returned for editing.': '{0}: رجع للتعديل.',
  '{0}: pending.': '{0}: في الانتظار.', '{0}: pending - {1}.': '{0}: في الانتظار - {1}.',
  'Reminder set for {0} at {1}': 'تم ضبط تذكير لـ{0} في {1}',
  'Reminder updated for {0}': 'تم تحديث تذكير لـ{0}',
  'Comment for {0}': 'تعليق على {0}',
  'Add a comment to choose a decision.': 'اكتب تعليق عشان تختار القرار.',
  '{0} lead': '{0} ليد', '{0} leads': '{0} ليد',
  'Queue unavailable. Use Refresh to try again.': 'الطابور مش متاح. اضغط تحديث عشان تحاول تاني.',
  'Request failed ({0})': 'الطلب فشل ({0})',
  'Unable to save language preference': 'تعذّر حفظ اختيار اللغة',
  'HTTPS required for notifications': 'الإشعارات محتاجة اتصال HTTPS',
  'Push notifications are not supported on this device': 'إشعارات المتصفح مش مدعومة على الجهاز ده',
  'Notifications are blocked in browser settings': 'الإشعارات مقفولة من إعدادات المتصفح',
  'Notification permission was not granted': 'إذن الإشعارات متوافقش عليه',
  'Push notifications enabled': 'تم تفعيل إشعارات المتصفح',
  'Failed to enable push notifications': 'تعذّر تفعيل إشعارات المتصفح',
  'Failed to get notification key from server': 'تعذّر تحميل مفتاح الإشعارات من السيرفر',
  'Missing notification public key': 'مفتاح الإشعارات العام مش موجود',
  'Server rejected push subscription': 'السيرفر رفض تسجيل إشعارات المتصفح',
  'You are offline. Check your connection.': 'الإنترنت مقطوع. اتأكد من الاتصال.',
  'SIMULATION': 'محاكاة', 'Simulation active: {0} (target {1})': 'المحاكاة شغالة: {0} (الهدف {1})',
  'employee #{0}': 'الموظف رقم {0}', 'student #{0}': 'الطالب رقم {0}',
  'none': 'مفيش', 'unknown': 'غير معروف', 'Stopping...': 'جاري الإيقاف...',
  'Stop': 'إيقاف', 'Cockpit': 'لوحة المطور', 'Simulation stopped': 'تم إيقاف المحاكاة',
  'Failed to stop simulation': 'تعذّر إيقاف المحاكاة',
  'sales': 'السيلز', 'sales manager': 'مدير السيلز', 'general manager': 'المدير العام',
  'team leader': 'قائد الفريق', 'tele sales': 'تيلي سيلز', 'ghosted sales': 'سيلز العملاء غير المتجاوبين',
};
export const shellAuditEnglishTranslations: Record<string, string> = {};
